import { BUTTON_SIZE, BUTTON_TYPE, DSButton, DSModal } from '@repo/design-system/index'
import { useCallback, useState } from 'react'

type Option = {
  title?: string
  content?: string
  confirmText?: string
  cancelText?: string
}

const useConfirmModal = () => {
  const [open, setOpen] = useState(false)
  const [options, setOptions] = useState<Option>({})
  const [resolver, setResolver] = useState<((value: boolean) => void) | null>(null)

  const confirm = useCallback((option: Option) => {
    setOptions(option)
    setOpen(true)
    return new Promise<boolean>((resolve) => {
      setResolver(() => resolve)
    })
  }, [])

  const close = useCallback(
    (value: boolean) => {
      setOpen(false)
      resolver?.(value)
      setResolver(null)
    },
    [resolver]
  )

  const modal: React.FC = () => {
    if (!open) return null
    return (
      <DSModal id={options.title} isOpen={open} setIsOpen={setOpen} size={'lg'}>
        <DSModal.Title>{options.title}</DSModal.Title>
        <DSModal.Content>{options.content}</DSModal.Content>
        <DSModal.ButtonContainer direction="horizontal">
          <DSButton type={BUTTON_TYPE.OUTLINE} size={BUTTON_SIZE.LG} onClick={() => close(false)}>
            <DSButton.Label>{options.cancelText}</DSButton.Label>
          </DSButton>
          <DSButton size={BUTTON_SIZE.LG} onClick={() => close(true)}>
            <DSButton.Label>{options.confirmText}</DSButton.Label>
          </DSButton>
        </DSModal.ButtonContainer>
      </DSModal>
    )
  }

  return {
    confirm,
    ConfirmModal: modal,
  }
}

export default useConfirmModal
